import { CSSProperties } from 'react';
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'autoCapitalize'>, Omit<LazyLoadImageProps, 'autoCapitalize'> {
	image: {
		src: string;
		alt?: string;
		height?: number | string;
		width?: number | string;
		caption?: string;
		style?: CSSProperties
	}
}

const LazyImage = ({ image, ...props }: ImageProps) => (
  <div>
    <LazyLoadImage
      alt={image.alt}
      src={image.src}
      height={image.height}
      width={image.width} 
			effect="blur"
			style={image.style}
			wrapperProps={props.wrapperProps ? props.wrapperProps : {}}
		/>
    {/* <span>{image.caption}</span> */}
  </div>
);

export default LazyImage;
